import {
    Dialog,
    DialogContent,
    Box,
    Typography,
    IconButton,
    useTheme,
} from "@mui/material"
import { Close } from "@mui/icons-material"
import veg from 'assests/Group 78.svg'
import nonVeg from 'assests/Group 92.svg'
import CustomTypography from "components/Fileds/CustomTypography"
import CustomButton from "components/Fileds/CustomButton"
import "./style.css";
import { foodItemType, typeIcons } from "utils/constant"
const AddOnsCofirmation = ({ open, onClose, item, onAddNew, onRepeatLast }) => {

    const theme = useTheme();

    if (!item) return null
    return (
        <Dialog className="add-ons-container" open={open} onClose={onClose} maxWidth="xs" fullWidth PaperProps={{ sx: { borderRadius: '20px', padding: '10px', color: 'black' } }}>
            <DialogContent sx={{
                p: 0, "&::-webkit-scrollbar": {
                    width: 0,
                    height: 0,
                }, msOverflowStyle: "none", scrollbarWidth: "none",
            }}
            >
                <Box className='close-icon-contianer'>
                    <IconButton onClick={onClose} className="close-icon">
                        <Close />
                    </IconButton>

                    <Box className='d-flex' sx={{ p: 2, pb: 0 }}>
                        <Box className='food-item-logo-container'>
                            <img
                                src={`${process.env.REACT_APP_API_ROUTE}/files/${item?.image}` || "/placeholder.svg"}
                                alt={'logo'}
                                className="food-item-logo"
                            />
                        </Box>
                        <Box>
                            <CustomTypography
                                variant={"caption"}
                                label={"Add-Ons for"}
                                sx={{
                                    mb: 0, fontSize: '14px', fontWeight: 300,
                                    color: theme.palette.typographyLabel.main
                                }}
                            />
                            <CustomTypography
                                label={item.name}
                                variant={"h6"}
                                sx={{
                                    marginTop: '-6px', fontSize: '24px', fontWeight: 700,
                                    color: theme.palette.typographyLabel.main,
                                    mb: 0
                                }}
                            />

                            {/* {item.type && (
                                <Box className='d-flex align-items-center' sx={{ mb: 2 }}>
                                    <Box sx={{ mr: 0, position: "relative" }}>
                                        <img
                                            src={item.type === "veg" ? veg : nonVeg}
                                            alt={'logo'}
                                            className="food-item-type-logo"
                                        />
                                    </Box>
                                    <Box className="food-item-type-text"
                                        component="span"
                                        sx={{ color: theme.palette.drawermenuitem.main }}
                                    >
                                        {item.type === "veg" ? "VEG" : "NON-VEG"}
                                    </Box>
                                </Box>
                            )} */}
                            {item.type && (
                                <Box className='d-flex align-items-center' sx={{ mb: 2 }}>
                                    <Box sx={{ mr: 0, position: "relative" }}>
                                        <img
                                            src={typeIcons[item.type] || typeIcons.veg}
                                            alt={'logo'}
                                            className="food-item-type-logo"
                                        />
                                    </Box>
                                    <Box className="food-item-type-text"
                                        component="span"
                                        sx={{ color: theme.palette.drawermenuitem.main, textTransform: 'uppercase' }}
                                    >
                                        {foodItemType.find(t => t.value === item.type)?.name || item.type}
                                    </Box>
                                </Box>
                            )}
                        </Box>
                    </Box>

                    <Box className='info-text-container'>
                        <CustomTypography
                            variant={"body1"}
                            label={"You have added this Item with Add-Ons already."}
                            sx={{ mb: 0, color: theme.palette.drawermenuitem.main, fontSize: '16px', fontWeight: 400 }}
                        />
                        <CustomTypography
                            variant={"body1"}
                            label={"How you would like your Add-Ons again?"}
                            sx={{ mb: 0, color: theme.palette.drawermenuitem.main, fontSize: '16px', fontWeight: 700 }}
                        />
                    </Box>

                    <Box className='d-flex align-items-center justify-content-center' sx={{ gap: '20px', mb: 2 }}>
                        <CustomButton
                            fullWidth
                            sx={{
                                border: `1px solid ${theme.palette.primary.main}`,
                                color: theme.palette.primary.main,
                                background: 'transparent',
                                borderRadius: '10px',
                                width: "160px"
                            }}
                            onClick={onAddNew}
                        >
                            Add New
                        </CustomButton>

                        <CustomButton
                            fullWidth
                            sx={{ borderRadius: "10px", width: "160px" }}
                            onClick={onRepeatLast}
                        >
                            Repeat Last
                        </CustomButton>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default AddOnsCofirmation
